export const laoA = [
  [
    [113.67468408146121, 23.018530871425053, 10],
    [113.67469919846171, 23.01854228857706, 10],
  ],
  [
    [113.67474284196504, 23.018459814846327, 10],
    [113.67475893076313, 23.018470030920323, 10],
  ],
  [
    [113.67479939852478, 23.018386318828533, 10],
    [113.67481554434404, 23.018396457521163, 10],
  ],
  [
    [113.67485258938021, 23.018311143772863, 10],
    [113.67486922478805, 23.018320579969433, 10],
  ],
  [
    [113.67490448519327, 23.01823471785501, 10],
    [113.67492114152961, 23.01824412235225, 10],
  ],
  [
    [113.67495484863807, 23.018157837423182, 10],
    [113.67497191198804, 23.01816659443437, 10],
  ],
  [
    [113.67500084286446, 23.01807901200734, 10],
    [113.67501859077429, 23.01808651314249, 10],
  ],
  [
    [113.67504296708994, 23.017997198105384, 10],
    [113.675060344002, 23.018005409798477, 10],
  ],
  [
    [113.6750852852567, 23.017915732953615, 10],
    [113.67510248130827, 23.017924264605924, 10],
  ],
  [
    [113.67512692503031, 23.017835065621345, 10],
    [113.6751448544831, 23.017842187177205, 10],
  ],
  [
    [113.67516422218372, 23.01775194170869, 10],
    [113.67518237262254, 23.0177585662671, 10],
  ],
  [
    [113.67520097744024, 23.017668320470918, 10],
    [113.67521912993689, 23.017674940170302, 10],
  ],
  [
    [113.67523718136394, 23.017584366529316, 10],
    [113.67525525486406, 23.01759116888365, 10],
  ],
  [
    [113.67527274470166, 23.017500487866858, 10],
    [113.67529095892526, 23.017506960606003, 10],
  ],
  [
    [113.67530806522487, 23.017416338760857, 10],
    [113.67532629048542, 23.017422784799056, 10],
  ],
  [
    [113.67534271100128, 23.017331855434186, 10],
    [113.67536088365586, 23.01733842746839, 10],
  ],
  [
    [113.6753774259767, 23.017247577633878, 10],
    [113.6753956734094, 23.017253969645864, 10],
  ],
  [
    [113.67541246249817, 23.01716318324442, 10],
    [113.67543061924859, 23.0171697927822, 10],
  ],
  [
    [113.67544728382377, 23.01707908257987, 10],
    [113.67546561517, 23.017085265391216, 10],
  ],
  [
    [113.67548092197083, 23.016994339900474, 10],
    [113.6754992647643, 23.01700049352467, 10],
  ],
  [
    [113.67551418376951, 23.01690933232733, 10],
    [113.67553244090988, 23.016915700432627, 10],
  ],
  [
    [113.67554956302932, 23.01682521396219, 10],
    [113.67556783405821, 23.01683154781802, 10],
  ],
  [
    [113.6755835881053, 23.016740619667896, 10],
    [113.67560188239202, 23.016746895710355, 10],
  ],
  [
    [113.67561791074377, 23.01665605911709, 10],
    [113.67563617769949, 23.016662402975136, 10],
  ],
  [
    [113.67565121597524, 23.01657081668548, 10],
    [113.67566919145541, 23.0165778377576, 10],
  ],
  [
    [113.67568763545547, 23.016487353810763, 10],
    [113.67570583134912, 23.01649387024855, 10],
  ],
  [
    [113.6757229707194, 23.016403205513953, 10],
    [113.67574117931572, 23.01640969145153, 10],
  ],
  [
    [113.67575782012234, 23.01631875748204, 10],
    [113.67577594624491, 23.01632543839864, 10],
  ],
  [
    [113.67579434227466, 23.01623434654617, 10],
    [113.67581191967645, 23.016242183675743, 10],
  ],
  [
    [113.6758373186502, 23.016152982523494, 10],
    [113.67585458938058, 23.016161383543018, 10],
  ],
  [
    [113.67588460699533, 23.01607345541493, 10],
    [113.6759013262073, 23.016082763421867, 10],
  ],
  [
    [113.67593581769914, 23.015995982669676, 10],
    [113.67595191782536, 23.016006183049907, 10],
  ],
  [
    [113.67599156018123, 23.015921264972548, 10],
    [113.67600701443003, 23.015932288126642, 10],
  ],
  [
    [113.67605298883447, 23.01585061455998, 10],
    [113.6760678223111, 23.01586234570037, 10],
  ],
  [
    [113.67611695047513, 23.015782594238992, 10],
    [113.67613194091327, 23.01579415315173, 10],
  ],
  [
    [113.67618264608195, 23.015715012820635, 10],
    [113.67619660364402, 23.01572763135078, 10],
  ],
  [
    [113.67625056673396, 23.01565021682303, 10],
    [113.67626454022721, 23.015662820230396, 10],
  ],
  [
    [113.67631896851712, 23.015586133736097, 10],
    [113.67633325040684, 23.015598437369345, 10],
  ],
  [
    [113.67638629710106, 23.015520527042124, 10],
    [113.67640028523427, 23.015533116514447, 10],
  ],
  [
    [113.67645395764602, 23.01545560290788, 10],
    [113.67646807592308, 23.015468067275393, 10],
  ],
  [
    [113.67652178137952, 23.015390590430684, 10],
    [113.67653577485855, 23.015403174799147, 10],
  ],
  [
    [113.67658963265538, 23.015325706762848, 10],
    [113.67660361890314, 23.015338298011205, 10],
  ],
  [
    [113.67665752042929, 23.015260967306617, 10],
    [113.67667161879038, 23.015273450955412, 10],
  ],
  [
    [113.67672308297938, 23.01519566831676, 10],
    [113.6767387637479, 23.015206413768986, 10],
  ],
  [
    [113.67677332235988, 23.015121499194933, 10],
    [113.67679142589238, 23.015128232022526, 10],
  ],
  [
    [113.67680901858229, 23.015037694837172, 10],
    [113.67682728177931, 23.015044047426695, 10],
  ],
  [
    [113.67684632794357, 23.014952729616272, 10],
    [113.67686317083906, 23.01496184434348, 10],
  ],
  [
    [113.67690381722058, 23.014878088648413, 10],
    [113.67691826855625, 23.014890221490774, 10],
  ],
  [
    [113.67696998280567, 23.014811179935567, 10],
    [113.67698381142048, 23.014823919447124, 10],
  ],
  [
    [113.67703816297535, 23.014746904654928, 10],
    [113.67705231247793, 23.01475933857594, 10],
  ],
  [
    [113.6771052284642, 23.0146813733613, 10],
    [113.67711942304008, 23.01469376317793, 10],
  ],
  [
    [113.677172172994, 23.014615678686393, 10],
    [113.6771863506086, 23.01462808512551, 10],
  ],
  [
    [113.67723982969913, 23.014550377527247, 10],
    [113.67725372986736, 23.01456305011487, 10],
  ],
  [
    [113.67730784885134, 23.014485824740746, 10],
    [113.67732193297087, 23.014498322079916, 10],
  ],
  [
    [113.67737512728996, 23.01442066998053, 10],
    [113.67738945740274, 23.01443292535491, 10],
  ],
  [
    [113.67744139718984, 23.0143542744561, 10],
    [113.67745558325065, 23.014366672593454, 10],
  ],
  [
    [113.67750863930576, 23.01428877818249, 10],
    [113.67752273773868, 23.01430126166597, 10],
  ],
  [
    [113.67757622249769, 23.014223431647146, 10],
    [113.6775900695485, 23.014236153933744, 10],
  ],
  [
    [113.67764494250663, 23.0141593431724, 10],
    [113.67765878953803, 23.014172065471136, 10],
  ],
  [
    [113.67771364160585, 23.01409524610355, 10],
    [113.67772749988667, 23.01410795789646, 10],
  ],
  [
    [113.67778229070984, 23.01403111857033, 10],
    [113.67779617683401, 23.014043804294978, 10],
  ],
  [
    [113.67784966609211, 23.01396617344208, 10],
    [113.67786392145784, 23.0139785032381, 10],
  ],
  [
    [113.67791708868448, 23.01390058062732, 10],
    [113.67793097054083, 23.013913270341412, 10],
  ],
  [
    [113.67798536970069, 23.013836306971545, 10],
    [113.67799948067766, 23.013848778260176, 10],
  ],
  [
    [113.67805279885293, 23.013770934160966, 10],
    [113.67806677938718, 23.013783530695775, 10],
  ],
  [
    [113.67812094919952, 23.013706371320595, 10],
    [113.6781349741515, 23.013718925469437, 10],
  ],
  [
    [113.67818871271257, 23.013641266257167, 10],
    [113.6782025739629, 23.01365397523318, 10],
  ],
  [
    [113.67825692829821, 23.013576816602292, 10],
    [113.67827089355426, 23.013589427631878, 10],
  ],
  [
    [113.67832538164194, 23.013512337570187, 10],
    [113.67833918547305, 23.013525099971787, 10],
  ],
  [
    [113.67839367629387, 23.013448525343954, 10],
    [113.67840817513465, 23.013460609372185, 10],
  ],
  [
    [113.67846100934362, 23.013383002382366, 10],
    [113.6784752561255, 23.013395340617308, 10],
  ],
  [
    [113.67852767286014, 23.01331708775756, 10],
    [113.67854192856883, 23.013329417147585, 10],
  ],
  [
    [113.67859225063832, 23.01325059369089, 10],
    [113.67860771267401, 23.01326160712356, 10],
  ],
  [
    [113.67864601600057, 23.013177806585578, 10],
    [113.67866362871165, 23.01318557472981, 10],
  ],
  [
    [113.67867826473359, 23.013097086096106, 10],
    [113.67869775003422, 23.013097990424992, 10],
  ],
  [
    [113.67867051476775, 23.013012831984, 10],
    [113.67868801163479, 23.01300484271174, 10],
  ],
  // [
  //   [113.67862276720108, 23.012938611030282, 10],
  //   [113.67863595243429, 23.012925300010476, 10],
  // ],
  // [
  //   [113.67854827626267, 23.012884094982248, 10],
  //   [113.67855820024346, 23.012868546315612, 10],
  // ],
  // [
  //   [113.67846321479819, 23.01284184082217, 10],
  //   [113.67847153058295, 23.012825503881363, 10],
  // ],
  // [
  //   [113.67837377058044, 23.012805883414515, 10],
  //   [113.67838212307139, 23.012789562527683, 10],
  // ],
  // [
  //   [113.67828436241129, 23.01277349083751, 10],
  //   [113.67829031407206, 23.012756292063656, 10],
  // ],
  // [
  //   [113.67819170361022, 23.012747193406867, 10],
  //   [113.6781964911681, 23.0127296859791, 10],
  // ],
  // [
  //   [113.67810056953626, 23.012721950022332, 10],
  //   [113.6781007188706, 23.012703890924822, 10],
  // ],
  // [
  //   [113.67800565792538, 23.01272087410207, 10],
  //   [113.67800275547054, 23.012703015445336, 10],
  // ],
  // [
  //   [113.67791430155091, 23.01274003932632, 10],
  //   [113.67790489915261, 23.012724215345454, 10],
  // ],
  // [
  //   [113.6778333264681, 23.012785830662132, 10],
  //   [113.67781993347124, 23.012772698591387, 10],
  // ],
  // [
  //   [113.67775909691831, 23.01284500818505, 10],
  //   [113.67774683341118, 23.012830962458953, 10],
  // ],
  // [
  //   [113.67768451528167, 23.012902281852277, 10],
  //   [113.6776713199746, 23.01288897939226, 10],
  // ],
  // [
  //   [113.67761275685672, 23.0129632731639, 10],
  //   [113.67759937249818, 23.0129501335339, 10],
  // ],
  // [
  //   [113.67754192317152, 23.013025311111456, 10],
  //   [113.67752849026554, 23.01301221399535, 10],
  // ],
  // [
  //   [113.67747026235128, 23.013086961976413, 10],
  //   [113.67745726001218, 23.013073497669566, 10],
  // ],
  // [
  //   [113.67739944143854, 23.01314725221449, 10],
  //   [113.6773846838188, 23.013135439695066, 10],
  // ],
  // [
  //   [113.67733544953343, 23.013215749563226, 10],
  //   [113.67732106494147, 23.013203549126768, 10],
  // ],
  // [
  //   [113.67726901170388, 23.01328201141452, 10],
  //   [113.67725479720389, 23.013269641329124, 10],
  // ],
  // [
  //   [113.67720219461387, 23.013347801022498, 10],
  //   [113.6771879801509, 23.013335430894013, 10],
  // ],
  // [
  //   [113.67713531180057, 23.013413601893152, 10],
  //   [113.67712117155466, 23.013401159086932, 10],
  // ],
  // [
  //   [113.67706810195402, 23.013479047840004, 10],
  //   [113.67705396170749, 23.01346660502788, 10],
  // ],
  // [
  //   [113.67700085507616, 23.013544510187632, 10],
  //   [113.67698676789638, 23.013532015898562, 10],
  // ],
  // [
  //   [113.67693299624015, 23.01360950657081, 10],
  //   [113.67691904766934, 23.013596879727174, 10],
  // ],
  // [
  //   [113.6768647922596, 23.013674065242874, 10],
  //   [113.67685084368853, 23.01366143839334, 10],
  // ],
  // [
  //   [113.67679658821389, 23.013738623885093, 10],
  //   [113.67678263964302, 23.013725997029216, 10],
  // ],
  // [
  //   [113.67672838401569, 23.013803182487734, 10],
  //   [113.67671443542505, 23.013790555644427, 10],
  // ],
  // [
  //   [113.67666017984037, 23.013867741069575, 10],
  //   [113.67664623124948, 23.013855114220366, 10],
  // ],
  // [
  //   [113.67659228537707, 23.013932321247072, 10],
  //   [113.67657806336638, 23.013919958495233, 10],
  // ],
  // [
  //   [113.67652625628925, 23.01399731230912, 10],
  //   [113.67651053696704, 23.013986615406697, 10],
  // ],
  // [
  //   [113.67646944993116, 23.014069884597852, 10],
  //   [113.67645295455654, 23.014060240824975, 10],
  // ],
  // [
  //   [113.67641750209667, 23.01414626117582, 10],
  //   [113.67640095942218, 23.014136687064042, 10],
  // ],
  // [
  //   [113.67636776785747, 23.014223473238538, 10],
  //   [113.67635080332064, 23.014214554050522, 10],
  // ],
  // [
  //   [113.67632022694009, 23.014302155631082, 10],
  //   [113.67630311235757, 23.01429348552394, 10],
  // ],
  // [
  //   [113.6762739417557, 23.0143814397201, 10],
  //   [113.6762566490678, 23.014373077891808, 10],
  // ],
  // [
  //   [113.67622784731877, 23.014461496593892, 10],
  //   [113.67621100879042, 23.01445237505365, 10],
  // ],
  // [
  //   [113.6761787747306, 23.014539102103996, 10],
  //   [113.67616154063968, 23.014530637217216, 10],
  // ],
  // [
  //   [113.67613392407172, 23.014619119411407, 10],
  //   [113.67611655965422, 23.014610885882696, 10],
  // ],
  // [
  //   [113.67608905668651, 23.01469938161364, 10],
  //   [113.6760717661276, 23.01469101594252, 10],
  // ],
  // [
  //   [113.6760435071717, 23.01477999380055, 10],
  //   [113.67602694035321, 23.01477045541339, 10],
  // ],
  // [
  //   [113.67598972361533, 23.014857428551018, 10],
  //   [113.67597555884709, 23.014845009522737, 10],
  // ],
  // [
  //   [113.67592229154666, 23.014922740441822, 10],
  //   [113.67590824756415, 23.01491020441882, 10],
  // ],
  // [
  //   [113.67585467564119, 23.014987644443917, 10],
  //   [113.67584043526792, 23.014975299709906, 10],
  // ],
  // [
  //   [113.67578793761977, 23.015054026249015, 10],
  //   [113.67577427829812, 23.015041131171937, 10],
  // ],
  // [
  //   [113.67571628997027, 23.01511574112805, 10],
  //   [113.67570323582343, 23.015102319686047, 10],
  // ],
  // [
  //   [113.67564588281753, 23.015177497484814, 10],
  //   [113.67563208790862, 23.015164726668072, 10],
  // ],
  // [
  //   [113.67557701401986, 23.015241414035327, 10],
  //   [113.67556318131115, 23.01522867829436, 10],
  // ],
  // [
  //   [113.6755082113416, 23.01530544446054, 10],
  //   [113.67549439761618, 23.015292691071366, 10],
  // ],
  // [
  //   [113.67543688741466, 23.015367777629915, 10],
  //   [113.6754239256596, 23.015354279660677, 10],
  // ],
  // [
  //   [113.67536030402783, 23.015425854446, 10],
  //   [113.6753497970602, 23.015410637407932, 10],
  // ],
  // [
  //   [113.67527575839861, 23.015474582521946, 10],
  //   [113.67526903229317, 23.015457630053582, 10],
  // ],
  // [
  //   [113.67518159062459, 23.015502860123515, 10],
  //   [113.6751781423916, 23.015485084808912, 10],
  // ],
  // [
  //   [113.67508166509943, 23.015509346498337, 10],
  //   [113.67508457130923, 23.01549148836384, 10],
  // ],
  // [
  //   [113.67498482784333, 23.015492779059894, 10],
  //   [113.67498991158227, 23.0154753433079, 10],
  // ],
  // [
  //   [113.67489354457894, 23.01545603928828, 10],
  //   [113.67490423783958, 23.015440933850577, 10],
  // ],
  // [
  //   [113.67481670108272, 23.015395705626272, 10],
  //   [113.67483311829254, 23.015385948005505, 10],
  // ],
  // [
  //   [113.67476844962427, 23.01531653138543, 10],
  //   [113.67478613175561, 23.015308899024625, 10],
  // ],
  // [
  //   [113.67474125608528, 23.015227295722966, 10],
  //   [113.6747607615579, 23.015226903226708, 10],
  // ],
  // [
  //   [113.67474387422362, 23.01513532389467, 10],
  //   [113.67476297908357, 23.015138985456996, 10],
  // ],
  // [
  //   [113.67476610235082, 23.015046093333783, 10],
  //   [113.67478443968717, 23.015052260207494, 10],
  // ],
  // [
  //   [113.67480396108627, 23.01496182733949, 10],
  //   [113.6748212304198, 23.014970230552517, 10],
  // ],
];
